export default __webpack_public_path__ + "static/logo21-f6317fa299fc2b175226ae1e65223e7a.png";